import {
  stringIsInvalid,
  stringMaxLengthIsInvalid,
} from 'store/utils/validators';
import MESSAGES from 'constants/messages';
import { OnCheckContextName } from '../../types';

type Validate = (
  field: string,
  onCheckDictionaryName: OnCheckContextName,
) => Promise<string>;

const validate: Validate = async (contextName, onCheckContextName) => {
  if (!contextName || stringIsInvalid(contextName)) {
    return MESSAGES.CONTEXTS.NAME.REGEX;
  }

  if (stringMaxLengthIsInvalid(contextName)) {
    return MESSAGES.CONTEXTS.NAME.MAX_LENGTH;
  }

  try {
    await onCheckContextName('contextName', contextName);
  } catch ({ contextName: errorMessage }) {
    return errorMessage;
  }

  return undefined;
};

export default validate;
